
export function sendEvent(event, ...data) {
    console.log(event,data,"event")
    // eslint-disable-next-line no-undef
    if (isFlutterInAppWebViewReady) {
        const args = {
            event: event,
            data: data
        };
        window.flutter_inappwebview.callHandler('Qushi', args);
    }
}

export function event(event, data) {
    console.log(event,data,"event")
    // eslint-disable-next-line no-undef
    if (isFlutterInAppWebViewReady) {
        const args = {
            event: event,
            data: data
        };
        window.flutter_inappwebview.callHandler('Qushi', args);
    }
}
